import { InstrumentsService } from './../../../price-and-valuation/state/instruments.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SbRoutingButton } from '@models';
import { SbEvent, SbEventBusService, SbEventTopic } from '../../../services';
import { GridApi, RowNode } from 'ag-grid-community';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SbAgTableButtonCellRendererParams } from '../sb-ag-table-button-renderer/sb-ag-table-button-cell-renderer-params';

@Component({
    selector: 'app-sb-ag-table-link-renderer',
    template: `
        <div *ngIf="isCompany" class="button-wrapper">
            <span>
                <button class="btn primary" (click)="buttonClicked()">
                    <i class="material-icons">arrow_forward</i>
                </button>
            </span>
        </div>
    `,
    styleUrls: ['./sb-ag-table-link-renderer.component.scss']
})
/**
 * For now this is implemented as a hard coded link to private equity overview.
 * In order to make this configurable for any table, please implement configuration properties / logic.
 */
export class SbAgTableLinkRendererComponent implements OnDestroy {
    constructor(
        private router: Router,
        private instrumentService: InstrumentsService,
        private eventBus: SbEventBusService
    ) {}
    button: SbRoutingButton;
    gridApi: GridApi;
    rowNode: RowNode;
    data: any;
    isCompany: boolean;
    unsubscribe$ = new Subject();

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    // gets called once before the renderer is used
    agInit(params: SbAgTableButtonCellRendererParams): void {
        this.button = params.button;
        this.gridApi = params.api;
        this.data = params.data;
        this.rowNode = params.node;
        this.isCompany = this.rowNode.data.underlyingInstrumentType === 'COMPANY';
    }

    buttonClicked() {
        this.instrumentService
            .getById(this.rowNode.data.underlyingInstrumentId)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((i) => {
                const emitEvent: SbEvent = {
                    source: 'TableLinkRenderer',
                    topic: SbEventTopic.CompanySelected,
                    payload: {
                        // event.value is the option data (as set as value in html)
                        value: i
                    }
                };
                this.eventBus.emit(emitEvent, true);
                this.router.navigate([`/private-equity/${i.instrumentId}`]);
            });
    }
}
